import {ApplicationEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
export const ApplicationsList = [{
  key: ApplicationEnum.Uber,
  value: 'Uber',
}, {
  key: ApplicationEnum.Bolt,
  value: 'Bolt',
}, {
  key: ApplicationEnum.FreeNow,
  value: 'Free Now',
}, {
  key: ApplicationEnum.UberEats,
  value: 'Uber Eats',
}, {
  key: ApplicationEnum.BoltFood,
  value: 'Bolt Food',
}, {
  key: ApplicationEnum.Glovo,
  value: 'Glovo',
}, {
  key: ApplicationEnum.XpressDelivery,
  value: 'Xpress Delivery',
}, {
  key: ApplicationEnum.Stuart,
  value: 'Stuart',
}, {
  key: ApplicationEnum.Lime,
  value: 'Lime',
}, {
  key: ApplicationEnum.Dpd,
  value: 'DPD',
}, {
  key: ApplicationEnum.Wolt,
  value: 'Wolt',
},
  {
    key: ApplicationEnum.SzamaExpress,
    value: 'Szama Express',
  }, {
    key: ApplicationEnum.ITaxi,
    value: 'iTaxi',
  }, {
    key: ApplicationEnum.Tasku,
    value: 'Tasku',
  },  {
    key: ApplicationEnum.Novapost,
    value: 'Novapost',
  }, {
    key: ApplicationEnum.Jush,
    value: 'Żabka Jush',
  }, {
    key: ApplicationEnum.Flovi,
    value: 'Flovi',
  }, {
    key: ApplicationEnum.None,
    value: i18n.t(LF.None),
  }];
